import moment from 'moment';
import React, { useEffect, useState } from 'react'
import classes from './veryNewProposalDesign.module.scss'
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { ItineraryFlight } from '../../atom/Types';
import { Time, handleDuration } from '../../atom/utilities/function';

interface props {
    day: number
    ind: number
    singleFlightData: ItineraryFlight
    setActiveFlight: React.Dispatch<React.SetStateAction<ItineraryFlight[]>>
    setFlightInfoModal: React.Dispatch<React.SetStateAction<boolean>>
}

const SingleFlightCard: React.FC<props> = ({ singleFlightData, setActiveFlight, setFlightInfoModal, day, ind }) => {


    const [displayPrice, setDisplayPrice] = useState<number>()


    useEffect(() => {


        singleFlightData?.connectionFlights?.sort((a, b) => {
            if (a.connectionFlightOrder === null || b.connectionFlightOrder === null)
                return -1
            else return a.connectionFlightOrder - b.connectionFlightOrder
        }

        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {

        let price = singleFlightData?.price
        if (singleFlightData.connectionFlights.length > 0) {
            singleFlightData.connectionFlights.forEach((element) => {
                if (price && element.price)
                    price = price + element.price

            })
        }
        if (singleFlightData.returnItineraryFlight !== null && price !== null && singleFlightData?.returnItineraryFlight?.price !== null) {
            price = price + singleFlightData?.returnItineraryFlight?.price
            if (singleFlightData?.returnItineraryFlight?.connectionFlights.length > 0) {
                singleFlightData?.returnItineraryFlight?.connectionFlights.forEach((element) => {
                    if (price && element.price)
                        price = price + element?.price

                });
            }
        }
        if (price)
            setDisplayPrice(price)

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])



    const handeleFlightDetails = (data: ItineraryFlight) => {

        data.day = day;
        data.ind = ind
        setActiveFlight([data])
        setFlightInfoModal(true)

    }

    return (
        <div className={singleFlightData.visibility === false ? classes.flightCard : classes.flightCardUnavailable}>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', background: 'white', padding: '10px' }}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div className={classes.SingleFlightCard}>
                        <div className={classes.FlightImage}>
                            <img className={classes.FlightImage} alt='fli' src={singleFlightData.flight?.logo?.url ? singleFlightData.flight?.logo?.url : ''} />
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: '30px', width: '100%' }}>
                            <div className={classes.FlightInfo}>
                                <div className={classes.FlightTag}>Depart</div>
                                <div className={classes.FlightName}>
                                    {`${singleFlightData.flight.departureAirport} (${singleFlightData?.flight?.departure?.airportCode
                                        ? singleFlightData?.flight?.departure?.airportCode
                                        : singleFlightData.flight.departureAirportCode
                                        }) - ${singleFlightData?.connectionFlights.length > 0
                                            ? singleFlightData?.connectionFlights[singleFlightData?.connectionFlights.length - 1]?.flight?.arrivalAirport
                                            : singleFlightData.flight.arrivalAirport
                                        } (${singleFlightData?.connectionFlights.length > 0
                                            ? singleFlightData?.connectionFlights[singleFlightData?.connectionFlights.length - 1].flight?.arrival?.airportCode
                                                ? singleFlightData?.connectionFlights[singleFlightData?.connectionFlights.length - 1].flight?.arrival?.airportCode
                                                : singleFlightData?.connectionFlights[singleFlightData?.connectionFlights.length - 1].flight?.arrivalAirportCode
                                            : singleFlightData?.flight?.arrival?.airportCode
                                                ? singleFlightData?.flight?.arrival?.airportCode
                                                : singleFlightData.flight.arrivalAirportCode
                                        })`}                                </div>
                                <div className={classes.DepartTime}>
                                    <div>{moment.utc(singleFlightData.departDate).format('dddd, MMMM D YYYY')}</div>
                                </div>
                                <div className={classes.Arrival}>
                                    <div>{Time(singleFlightData?.departTime)} -&nbsp;
                                        {singleFlightData?.connectionFlights.length > 0 ? Time(singleFlightData?.connectionFlights[singleFlightData?.connectionFlights.length - 1].arrivalTime) : Time(singleFlightData?.arrivalTime)}</div>
                                    <div className={classes.DepartTime}>{handleDuration(singleFlightData, 'n')}</div>
                                    {singleFlightData?.connectionFlights?.length > 0 ? <div className={classes.DepartTime} style={{ color: '#FF3566' }}> {singleFlightData.connectionFlights.length} stop</div> : <div className={classes.DepartTime} style={{ color: '#FF3566' }}> Direct Flight</div>}
                                </div>
                            </div>
                        </div>
                    </div>
                    {singleFlightData.returnItineraryFlight !== null ? <div className={classes.SingleFlightCard}>
                        <div className={classes.FlightImage} >
                            <img className={classes.FlightImage} alt='fli' src={singleFlightData.returnItineraryFlight?.flight?.logo?.url ? singleFlightData.returnItineraryFlight?.flight?.logo?.url : ''} />
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: '30px', width: '100%' }}>
                            <div className={classes.FlightInfo}>
                                <div className={classes.FlightTag}>Arrival</div>
                                <div className={classes.FlightName}>
                                    ${singleFlightData.returnItineraryFlight?.flight.departureAirport}
                                    (${singleFlightData.returnItineraryFlight?.flight.departure?.airportCode || singleFlightData.returnItineraryFlight?.flight.departureAirportCode})
                                    -
                                    ${singleFlightData?.returnItineraryFlight?.connectionFlights.length > 0
                                        ? singleFlightData?.returnItineraryFlight?.connectionFlights[singleFlightData?.returnItineraryFlight?.connectionFlights.length - 1]?.flight?.arrivalAirport
                                        : singleFlightData.returnItineraryFlight?.flight.arrivalAirport
                                    }
                                    (${singleFlightData?.returnItineraryFlight?.connectionFlights.length > 0
                                        ? singleFlightData?.returnItineraryFlight?.connectionFlights[singleFlightData?.returnItineraryFlight?.connectionFlights.length - 1].flight.arrival?.airportCode
                                            ? singleFlightData?.returnItineraryFlight?.connectionFlights[singleFlightData?.returnItineraryFlight?.connectionFlights.length - 1].flight.arrival?.airportCode
                                            : singleFlightData?.returnItineraryFlight?.connectionFlights[singleFlightData?.returnItineraryFlight?.connectionFlights.length - 1].flight.arrivalAirportCode
                                        : singleFlightData?.returnItineraryFlight?.flight.arrival?.airportCode
                                            ? singleFlightData?.returnItineraryFlight?.flight.arrival?.airportCode
                                            : singleFlightData?.returnItineraryFlight?.flight.arrivalAirportCode
                                    })
                                    `                                </div>
                                <div className={classes.DepartTime}>
                                    <div>{moment.utc(singleFlightData.returnItineraryFlight?.departDate).format('dddd, MMMM D YYYY')}</div>
                                </div>
                                <div className={classes.Arrival}>
                                    <div>{Time(singleFlightData?.returnItineraryFlight?.departTime)} -&nbsp;
                                        {singleFlightData?.returnItineraryFlight?.connectionFlights.length > 0 ? Time(singleFlightData?.returnItineraryFlight?.connectionFlights[singleFlightData?.returnItineraryFlight?.connectionFlights.length - 1].arrivalTime) : Time(singleFlightData?.returnItineraryFlight?.arrivalTime)}</div>
                                    <div className={classes.DepartTime}>{handleDuration(singleFlightData?.returnItineraryFlight, 'n')}</div>
                                    {singleFlightData?.returnItineraryFlight?.connectionFlights?.length > 0 ? <div className={classes.DepartTime} style={{ color: '#FF3566' }}> {singleFlightData.returnItineraryFlight?.connectionFlights.length} stop</div> : <div className={classes.DepartTime} style={{ color: '#FF3566' }}> Direct Flight</div>}
                                </div>
                            </div>
                        </div>
                    </div> : null}
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: "space-between" }}>
                    <div style={{ marginRight: '8px' }} className={classes.packagePrice}>${displayPrice}</div>
                    <div className={classes.DetailsTextContainer} onClick={() => { handeleFlightDetails(singleFlightData) }} >
                        <div>Details</div>
                        <KeyboardArrowRightIcon />
                    </div>
                </div>
            </div>



            {
                singleFlightData.selected ?
                    <div style={{ backgroundColor: "#0094FF", display: 'flex', flexDirection: 'row', padding: "5px", alignItems: 'center', borderBottomLeftRadius: '4px', borderBottomRightRadius: '4px' }}>
                        <CheckCircleRoundedIcon style={{ color: "white", transform: "scale(0.8)" }} />
                        <div style={{ color: 'white', fontWeight: '500' }}>Selected</div>
                    </div> : null
            }
        </div>

    )
}

export default SingleFlightCard